var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiData3 = function SvgAiData3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#204969",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.536 47.264c2.048 3.008 4.776 4.528 6.384 5.208.016 0 .024-.008.04-.016V42.152h-8.096c.512 2.856 1.144 4.344 1.672 5.112M46.184 34.696a11.2 11.2 0 0 1-4.216-2.632l-.008.008v10.056h7.704c.592-2.6.92-5.264 1.096-6.68l.024-.152c-1.24.088-2.848.016-4.6-.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42 22c-11.048 0-20 8.952-20 20s8.952 20 20 20 20-8.952 20-20-8.952-20-20-20m10.136 13.624c-.376 3.04-1.256 10.176-3.648 13.2a18.6 18.6 0 0 1-6.208 5.04L42 54l-.288-.12c-1.704-.68-4.912-2.344-7.304-5.84-1.4-2.04-2.32-6.472-2.728-13.144-.008-.144-.08-1.216-.08-1.216l.864.152a9.73 9.73 0 0 0 5.368-.6A9.86 9.86 0 0 0 41.44 30.6l.512-.6.52.6a9.97 9.97 0 0 0 4.16 2.8 9.86 9.86 0 0 0 4.84.432l.944-.144s-.224 1.496-.28 1.936"
  })));
};
export default SvgAiData3;